import { Component, Output, OnInit, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { ENGLISH_ID, SWEDISH_ID, FINNISH_ID, LanguageService, DANISH_ID } from '../../../core/service/language.service';

type LangItem = {
  id: number;
  textId: string;
};

export enum LanguageSelectorType {
  CONTEXT = 0,
  SLIDER = 1,
}

@Component({
    selector: 'app-language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguageSelectComponent implements OnInit {
  public SelectorType = LanguageSelectorType;
  showMenu: boolean;
  itemsSource: LangItem[];
  itemsSourceWithoutSelected: LangItem[];
  selectedItem: LangItem;
  private _languages: LangItem[];
  @Output() languageChange: EventEmitter<void>;
  @Input() type: LanguageSelectorType = LanguageSelectorType.CONTEXT;

  constructor(private readonly _language: LanguageService) {
    this.languageChange = new EventEmitter<void>();
  }

  ngOnInit(): void {
    this._languages = [
      { id: ENGLISH_ID, textId: 'ENGLISH_TEXT' },
      { id: SWEDISH_ID, textId: 'SWEDISH_TEXT' },
      { id: DANISH_ID, textId: 'DANISH_TEXT' },
      { id: FINNISH_ID, textId: 'FINNISH_TEXT' },
    ];

    this.selectedItem = this._languages.find(x => x.id === this._language.currentLanguageId);
    this.itemsSource = this._languages;
    this.itemsSourceWithoutSelected = this._languages.filter(x => x.id !== this._language.currentLanguageId);
  }

  toggleShowMenu() {
    this.showMenu = !this.showMenu;
  }

  select(id: number) {
    this._language.setLanguage(id);
    this.selectedItem = this._languages.find(x => x.id === id);
    this.itemsSource = this._languages;
    this.itemsSourceWithoutSelected = this._languages.filter(x => x.id !== id);
    this.languageChange.emit();
  }

  close() {
    this.showMenu = false;
  }
}
